import React, { Component } from 'react';
import btnStyles from 'styles/partials/_button.css';
import componentStyles from 'styles/partials/_baseinput.css';

export default class DisplayList extends Component {
  constructor(props) {
    super(props);
    this.createList = this.createList.bind(this);
    this.addToList = this.addToList.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.removeFromList = this.removeFromList.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.updateStore = this.updateStore.bind(this);

    this.state = {
      item: null,
    };
  }

  createList(testid) {
    const propsValue = this.props.value || [];
    let count = -1;
    let labelCount = -1;
    const valueList = this.addToList(propsValue);
    return valueList?.map((value) => {
      count++;
      if (value.deleted === true) {
        return;
      }

      labelCount++;

      const disabled = this.props.readOnly ? true : null;
      return (
        <div ref="inputgroup" key={`alias${count}`} className={componentStyles.inputGroup}>
          <label ref="label" className={componentStyles.inputLabel}>
            {`${this.props.label} ${labelCount + 1}`}
          </label>

          <div className={componentStyles.inputContainer}>
            <input
              data-testid={`${testid}-${count + 1}`}
              type="text"
              className={componentStyles.inputControl}
              key={this.props.objectKey + value.id}
              onChange={this.changeValue.bind(this, count)}
              onFocus={this.selectItem.bind(this, count)}
              value={value[this.props.objectKey]}
              disabled={disabled}
            />
          </div>
        </div>
      );
    });
  }

  addToList(list) {
    const returnList = list.slice(0);
    const value = { [this.props.objectKey]: '' };
    if (
      !returnList.some(
        (item) =>
          item && item.deleted !== true && (!item[this.props.objectKey] || item[this.props.objectKey].trim() === '')
      )
    ) {
      returnList.push(value);
    }
    return returnList;
  }

  changeValue(count, event) {
    const value = event.target.value;

    if (value === '' && count > 0) {
      this.removeFromList();
      return;
    }

    const list = this.props.value.slice();
    list[count] = Object.assign({}, list[count], {
      [this.props.objectKey]: value,
    });

    this.updateStore(list);
  }

  updateStore(list) {
    this.props.onChange(list);
  }

  selectItem(i) {
    this.setState({
      item: i,
    });
  }

  removeFromList(e) {
    e?.preventDefault();
    const list = this.props.value.slice();
    list[this.state.item] = Object.assign({}, list[this.state.item], {
      deleted: true,
    });
    if (this.state.item !== null) {
      this.setState({
        item: null,
      });
      this.props.onChange(list);
    }
  }

  render() {
    const testid = `dl-${this.props.dataid}`;
    const dataList = this.createList(testid);
    return (
      <div>
        {!this.props.readOnly ? (
          <div>
            <a
              data-testid={`${testid}-remove`}
              className={btnStyles.btnSecondarySmall}
              href="#"
              onClick={this.removeFromList}
            >
              Remove
            </a>
          </div>
        ) : null}
        {dataList}
      </div>
    );
  }
}

DisplayList.defaultProps = {
  value: [],
};
